import { Cmd, Loop, loop, LoopReducer } from "redux-loop";
import { ActionType, createAction, getType } from "typesafe-actions";
import {
  getCertNew,
  newCertSend,
  setErrorMessageMissingCertFields,
} from "../certs/certReducer";
import {
  getEventAsync,
  createEventAsync,
  getDraggableForm,
  sendRegistrationAsync,
  saveRegistrationQuestions,
  getEventDetails,
  postLinkForm,
  getLinkSuggestion,
} from "../events/eventReducer";
import { getAllEventsAsync } from "../events/listEvents/listEventsReducer";
import { loginAsync } from "../login/loginReducer";
import { ErrorState } from "../types/types";
import { getFormAsync } from "./formReducer";

const initialState: ErrorState = {
  message: "",
};

const clearErrorMessage = createAction("CLEAR_ERROR_MESSAGE")<undefined>();

type Action =
  | ActionType<typeof clearErrorMessage>
  | ActionType<typeof getFormAsync>
  | ActionType<typeof getEventAsync>
  | ActionType<typeof getAllEventsAsync>
  | ActionType<typeof loginAsync>
  | ActionType<typeof getDraggableForm>
  | ActionType<typeof createEventAsync>
  | ActionType<typeof sendRegistrationAsync>
  | ActionType<typeof saveRegistrationQuestions>
  | ActionType<typeof getEventDetails>
  | ActionType<typeof postLinkForm>
  | ActionType<typeof getLinkSuggestion>
  | ActionType<typeof getCertNew>
  | ActionType<typeof newCertSend>
  | ActionType<typeof setErrorMessageMissingCertFields>;

export const errorReducer: LoopReducer<ErrorState, Action> = (
  state: ErrorState = initialState,
  action: Action
): ErrorState | Loop<ErrorState> => {
  switch (action.type) {
    case getType(createEventAsync.success):
      return { ...state, message: null };
    case getType(getAllEventsAsync.success):
      return { ...state, message: null };
    case getType(getEventDetails.success):
      return { ...state, message: null };
    case getType(loginAsync.success):
      return { ...state, message: null };
    case getType(getFormAsync.success):
      return { ...state, message: null };
    case getType(getDraggableForm.success):
      return { ...state, message: null };
    case getType(getEventAsync.success):
      return { ...state, message: null };
    case getType(sendRegistrationAsync.success):
      return { ...state, message: null };
    case getType(saveRegistrationQuestions.success):
      return { ...state, message: null };
    case getType(postLinkForm.success):
      return { ...state, message: null };
    case getType(getLinkSuggestion.success):
      return { ...state, message: null };
    case getType(getCertNew.success):
      return { ...state, message: null };
    case getType(newCertSend.success):
      return { ...state, message: null };
    case getType(loginAsync.failure):
      return { ...state, message: action.payload.message };
    case getType(getEventAsync.failure):
      return { ...state, message: action.payload.message };
    case getType(getAllEventsAsync.failure):
      return { ...state, message: action.payload.message };
    case getType(getFormAsync.failure):
      return { ...state, message: action.payload.message };
    case getType(getDraggableForm.failure):
      return { ...state, message: action.payload.message };
    case getType(createEventAsync.failure):
      return { ...state, message: action.payload.message };
    case getType(sendRegistrationAsync.failure):
      return { ...state, message: action.payload.message };
    case getType(saveRegistrationQuestions.failure):
      return { ...state, message: action.payload.message };
    case getType(getEventDetails.failure):
      return { ...state, message: action.payload.message };
    case getType(postLinkForm.failure):
      return { ...state, message: action.payload.message };
    case getType(getLinkSuggestion.failure):
      return { ...state, message: action.payload.message };
    case getType(getCertNew.failure):
      return { ...state, message: action.payload.message };
    case getType(newCertSend.failure):
      return { ...state, message: action.payload.message };
    case getType(setErrorMessageMissingCertFields):
      const missingFields = action.payload.join(", ");
      return loop(
        {
          ...state,
          message: `Error: Can not send cert! Missing required fields: \n\n${missingFields}`,
        },
        Cmd.setTimeout(Cmd.action({ type: "CLEAR_ERROR_MESSAGE" }), 3000)
      );
    case getType(clearErrorMessage):
      return { ...state, message: null };
    default:
      return state;
  }
};

export function getErrorMessage(state): { message: string } {
  return { message: state.errorState.message };
}
